import { useLoggedOutSuppliersPageIsPending } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { useLoggedOutSuppliersPagePaginationData } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPagePaginationData";
import { getCurrentPath } from "@faire/web/common/Path";
import { Pagination } from "@faire/web/slate-deprecated/Pagination";
import { Column, HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import isUndefined from "lodash/isUndefined";
import React from "react";

export const LoggedOutSuppliersPagePagination: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  const isLoading = useLoggedOutSuppliersPageIsPending();
  const paginationData = useLoggedOutSuppliersPagePaginationData();

  const getPageLinkHandler = (pageNumber: number): string => {
    const currentFilterPath = getCurrentPath().delete("page");
    if (pageNumber === 1) {
      return currentFilterPath.toString();
    }
    return currentFilterPath.append({ page: pageNumber.toString() }).toString();
  };

  if (
    isLoading ||
    isUndefined(paginationData) ||
    paginationData.page_count === 1
  ) {
    return null;
  }

  return (
    <Column align="center">
      <HorizontalLine />
      <Spacer height="3x" />
      <Pagination
        paginationData={paginationData}
        onChangePage={scrollToBrandsSection}
        pageToLink={getPageLinkHandler}
      />
      <Spacer height="3x" />
    </Column>
  );
};
